module.exports = __webpack_public_path__ + "img/115.28a5fad7.jpg";